function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#a62731",
  d: "M4.937 6.664c-.958 0-1.747.789-1.747 1.747v15.72c0 .96.789 1.749 1.747 1.749h22.128c.958 0 1.746-.79 1.746-1.748V8.41c0-.958-.788-1.747-1.746-1.747H4.937zm0 1.164h22.128a.57.57 0 01.582.583v15.72a.57.57 0 01-.582.584H4.937a.57.57 0 01-.583-.583V8.41a.57.57 0 01.583-.583zm1.692 1.747a.583.583 0 00-.527.582v4.659c0 .32.261.582.583.582h4.076a.583.583 0 00.582-.582v-4.66a.583.583 0 00-.582-.581H6.684a.505.505 0 00-.055 0zm.637 1.165h2.911v3.494H7.266V10.74zm6.933 4.076a.583.583 0 00.054 1.164h5.241a.582.582 0 10.016-1.163h-5.257a.323.323 0 00-.054-.001zm0 2.33a.582.582 0 10.054 1.164h11.063a.583.583 0 00.019-1.164H14.253a.486.486 0 00-.054 0zm0 2.33a.581.581 0 00-.555.608c.015.32.288.57.609.556h11.063a.581.581 0 100-1.164H14.253a.244.244 0 00-.054 0zm0 2.327a.584.584 0 00.054 1.165h11.063a.582.582 0 10.019-1.165H14.253a.486.486 0 00-.054 0z"
});

function SvgPostcard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), _ref);
}

export default SvgPostcard;